enum COMMENT_IMAGE_SIZE {
  small = '80x80',
  BIG = '448x200',
  BIG_NO_HEIGHT = '535',
}
enum AVATAR_IMAGE_SIZE {
  TINY = '40x40',
  SMALL = '60x60',
  MEDIUM = '100x100',
  BIG = '285x285',
}
enum COMMUNITY_IMAGE_SIZE {
  // small = '230x99', // unused but it may be good to keep it for later
  SQUARE = '150x150',
  MEDIUM = '448x200',
  BIG = '990x427',
  PREVIEW = '300x129',
}
enum PUBLICATION_IMAGE_SIZE {
  MEDIUM = '350x140',
  MEDIUM_NO_HEIGHT = '350',
  BIG = '380x272',
  BIG_NO_HEIGHT = '680',
}

/**
 * We can request whatever dimension we want, but it will then be cached on the filesystem.
 * To avoid generating a bazillion dimensions, please use the following constants.
 *
 * Note: "80" !== "80x80". The first one will restrict the width and let the height be whatever it wants.
 */
export const IMAGE_SIZE = {
  COMMENT: COMMENT_IMAGE_SIZE,
  AVATAR: AVATAR_IMAGE_SIZE,
  COMMUNITY: COMMUNITY_IMAGE_SIZE,
  PUBLICATION: PUBLICATION_IMAGE_SIZE,
}
